import dayjs from 'dayjs';

const getHoursByDate = (findIn, date) => findIn?.find((item) => dayjs(item.Day).isSame(date))?.TotalHrs || 0;

const getIsPerDiemByDate = (findIn, date) => findIn?.find((item) => dayjs(item.Date).isSame(date))?.IsPerDiem || false;

const getTotals = (data) => {
  const workTypes = {
    'Straight Time': 'Straight Time',
    Overtime: 'Overtime',
    PTO: 'PTO'
  };

  const totals = {
    'Straight Time': 0,
    Overtime: 0,
    PTO: 0,
    'Total Time': 0
  };

  data.forEach((row) => {
    const counter = row.TimesheetHoursByDates.reduce((accumulator, day) => accumulator + Number(day.TotalHrs), 0);

    totals[workTypes[row.WorkType.Name]] += counter;
    totals['Total Time'] += counter;
  });

  return totals;
};

const getDatesForWeek = (startDateOfPeriod) =>
  Array.from({ length: 7 }, (v, k) => k).map((value) => dayjs(startDateOfPeriod).add(value, 'day'));

export { getHoursByDate, getTotals, getDatesForWeek, getIsPerDiemByDate };
